'use strict';

module.exports = {
    object: 'object',
};
